import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/joy/Box';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { LAYOUT } from '../theme/layoutTokens';

export type DashboardCrumb = { label: string; href?: string };

interface DashboardPageHeaderProps {
  breadcrumbs?: DashboardCrumb[];
  title: string;
  action?: React.ReactNode;
}

const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({
  breadcrumbs = [],
  title,
  action,
}) => {
  return (
    <Box sx={{ mb: LAYOUT.headerMarginBottom }}>
      {breadcrumbs.length > 0 ? (
        <Breadcrumbs
          aria-label="Ruta"
          size="sm"
          sx={{ mb: LAYOUT.breadcrumbsGap, '--Breadcrumbs-gap': '8px' }}
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            if (crumb.href && !isLast) {
              if (index === 0 && crumb.href === '/') {
                return (
                  <Link
                    key={`${crumb.label}-${index}`}
                    component={RouterLink}
                    to={crumb.href}
                    underline="hover"
                    color="neutral"
                    sx={{ display: 'inline-flex', alignItems: 'center' }}
                  >
                    <HomeRoundedIcon sx={{ fontSize: 18 }} />
                  </Link>
                );
              }
              return (
                <Link
                  key={`${crumb.label}-${index}`}
                  component={RouterLink}
                  to={crumb.href}
                  underline="hover"
                  color="neutral"
                >
                  {crumb.label}
                </Link>
              );
            }
            return (
              <Typography key={`${crumb.label}-${index}`} level="body-sm" sx={{ color: 'text.secondary' }}>
                {crumb.label}
              </Typography>
            );
          })}
        </Breadcrumbs>
      ) : null}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        gap={LAYOUT.titleBlockGap}
      >
        <Typography
          level="h1"
          sx={{
            fontSize: { xs: '1.35rem', sm: '1.5rem', md: '1.75rem' },
            fontWeight: 'lg',
            letterSpacing: '-0.02em',
          }}
        >
          {title}
        </Typography>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Stack>
    </Box>
  );
};

export default DashboardPageHeader;
